import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getDiscount = id => {
  return http.get(
    `${getBaseUrl()}/discount/${id}`
  );
};

export const getDiscounts = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/discount`
    );
  }
  return http.get(
    `${getBaseUrl()}/discount?${paginate}`
  );
};

export const updateDiscount = data => {

  return http.put(
    `${getBaseUrl()}/discount/${data.id}`,
    data
  );
};
export const submitDiscount = data => {

  return http.post(
    `${getBaseUrl()}/discount`,
    data
  );
};
